import { render, staticRenderFns } from "./PageFenye.vue?vue&type=template&id=2fa5c9bb"
import script from "./PageFenye.vue?vue&type=script&lang=js"
export * from "./PageFenye.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports